import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full flex flex-col" }
const _hoisted_3 = { class: "follow-businesses__item--name text-center flex-1 flex items-center justify-center" }
const _hoisted_4 = { class: "overflow-hidden text-ellipsis line-clamp-3" }
const _hoisted_5 = { class: "follow-businesses__item--btn w-[168px] mx-auto mt-auto flex justify-center pt-4" }
const _hoisted_6 = {
  key: 0,
  class: "follow-businesses__scroll-controls mt-[18px] flex items-center gap-[30px]"
}
const _hoisted_7 = { class: "follow-businesses__scrollbar relative h-[4px] flex-1 rounded-full bg-[#E5E5E5] overflow-hidden" }
const _hoisted_8 = { class: "follow-businesses__scroll-buttons flex shrink-0 gap-[14px]" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "txt__notoR16 txt__black flex items-center justify-center w-full rounded-lg mt-[20px] p-[30px] border border-[#A3A3A3] text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.followedBusinesses.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "follow-businesses__list txt__black txt__notoSB16 relative flex items-stretch overflow-x-auto snap-x snap-mandatory scroll-px-[30px] md:scroll-pl-[30px] gap-4 px-[30px] md:px-0 pb-[10px]",
          id: "followButton",
          ref: "scrollContainer",
          onScroll: $setup.updateScrollState
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.followedBusinesses, (business, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["follow-businesses__item relative border p-[30px] rounded-lg flex min-h-[164px] snap-center md:snap-start shrink-0 basis-[200px] sm:basis-[240px]", index % 2 === 0 ? 'border-[#749F54]' : 'border-[#E47348]']),
              key: business.id
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(business['name']), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode($setup["VueFollowButton"], {
                    "is-logged-in": $setup.props.isLoggedIn,
                    "business-id": business.id,
                    mode: "mypage",
                    onUnfollow: $setup.handleUnfollow
                  }, null, 8 /* PROPS */, ["is-logged-in", "business-id"])
                ])
              ])
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* NEED_HYDRATION, NEED_PATCH */),
        ($setup.isScrollable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "follow-businesses__scrollbar-thumb absolute left-0 top-0 h-full rounded-full bg-[#888888]",
                  style: _normalizeStyle({ width: `${$setup.scrollThumbWidth}%`, left: `${$setup.scrollThumbLeft}%` })
                }, null, 4 /* STYLE */)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "follow-businesses__scroll-button flex h-[46px] w-[46px] items-center justify-center rounded-full border border-[#A3A3A3] bg-white text-[28px] leading-none disabled:opacity-30",
                  type: "button",
                  disabled: !$setup.canScrollPrev,
                  onClick: $setup.scrollPrev,
                  "aria-label": "前へ"
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "material-symbols-outlined !text-4xl" }, "chevron_left", -1 /* CACHED */)
                ]), 8 /* PROPS */, _hoisted_9),
                _createElementVNode("button", {
                  class: "follow-businesses__scroll-button flex h-[46px] w-[46px] items-center justify-center rounded-full border border-[#A3A3A3] bg-white text-[28px] leading-none disabled:opacity-30",
                  type: "button",
                  disabled: !$setup.canScrollNext,
                  onClick: $setup.scrollNext,
                  "aria-label": "次へ"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "material-symbols-outlined !text-4xl" }, "chevron_right", -1 /* CACHED */)
                ]), 8 /* PROPS */, _hoisted_10)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[2] || (_cache[2] = [
        _createTextVNode("現在フォローしている団体はありません。", -1 /* CACHED */),
        _createElementVNode("br", null, null, -1 /* CACHED */),
        _createTextVNode("プロジェクトからお気に入りのオーナー (地域団体) を見つけましょう！", -1 /* CACHED */)
      ])))
}